import React, { useState } from 'react';

const LowRisk = () => {

    const [displayDropdown, setdisplayDropdown] = useState(false)
    const [displayDropdown2, setdisplayDropdown2] = useState(false)


    const handleDropDown = () => {
        if (displayDropdown === true) {
            setdisplayDropdown(false)
        } else {
            setdisplayDropdown(true)
        }
    }

    const handleDropDown2 = () => {
        if (displayDropdown2 === true) {
            setdisplayDropdown2(false)
        } else {
            setdisplayDropdown2(true)
        }
    }

    return (
        <div>
            <div className="pb-20">

            <div className="inline-block flex justify-between bg-gray-200 rounded-m px-3 my-2 py-2 text-2xl font-semibold transition duration-500 ease-in-out hover:bg-black hover:text-white transform hover:-translate-y-1 hover:scale-110">
                    <p>CETES</p>
                    <p onClick={handleDropDown2} className="cursor-pointer">+</p>                 
                </div>
                    
                {displayDropdown2 ? <div className="block w-full bg-gray-200 rounded-m px-3 my-2 py-2 text-2xl font-semibold mr-2 "> 
                    <p className='text-sm py-2 px-1 text-justify'> Los CETES (Certificados de la Tesorería de la Federación) Son pagarés emitido por el Gobierno Federal para recaudar fondos en un cierto plazo y que generan rendimientos a quienes invierten en ellos.</p>
                    <p className='text-sm py-2 px-1 text-justify'>Son considerados instrumentos seguros ya que su nivel de riesgo es muy bajo.</p>
                    <p className='text-sm py-2'>Estos son algunos CETES en los que puedes invertir en México y su rendimiento de 2019:</p>
                    <ul className="inline-block flex-row justify-between w-full list-disc px-10" >
                        <li className='text-sm text-left p-2 '>Cetes directo 28 días ( + 8.00 % )</li>
                        <li className='text-sm text-left p-2 '>Cetes directo 91 días ( + 8.28 % )</li>
                        <li className='text-sm text-left p-2 '>Cetes directo 182 días ( + 8.50 % )</li>

                    </ul >
                    <div className='text-center lg:my-48 py-10'>
                            <button className="shadow bg-black text-white font-bold py-4 px-12 rounded-full text-lg transition duration-500 ease-in-out hover:bg-teal-500 hover:text-white transform hover:-translate-y-1 hover:scale-110"  type='button'>Invertir</button>
                    </div>

                </div> : null } 

            </div>
        </div>
    );
}

export default LowRisk;

